import { ObtenerParametrizacionMS } from './open-api/model/obtenerParametrizacionMS';
import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserIdleService } from 'angular-user-idle';
import { setTheme } from 'ngx-bootstrap/utils';
import { AuthService } from 'src/app/core/services/auth.service';
import { UserModel } from './core/models/user.model';
import { EnvironmentService } from './core/services/environment.service';
import { VerificaSesionME } from './open-api/model/verificaSesionME';
import { AccesoService } from './open-api';
import Swal from 'sweetalert2';
import { IpCountryService } from './core/services/ip-country.service';
import { ConfigModel } from './config/config.model';
import { ParametrizacionService } from './open-api/api/parametrizacion.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  private sessionKey = 'token';
  title = 'FBSBancaEmpresa';
  user: UserModel = {};
  parametrizacion?: ObtenerParametrizacionMS;
  protected configModel?: ConfigModel;

  constructor(
    private parametrizacionService: ParametrizacionService,
    private userIdle: UserIdleService,
    private accesoService: AccesoService,
    private authService: AuthService,
    private ipCountryService: IpCountryService,
    // private environment: EnvironmentService
  ) {
    setTheme('bs4');
  }
  @HostListener('window:beforeunload', ['$event'])
  clearLocalStorage(event: any): void {
    localStorage.clear();
  }

  async ngOnInit(): Promise<void> {
    await this.ipCountryService.updateIpCountry().toPromise().then(ipCountry => {
      this.ipCountryService.ipCountry = ipCountry;
    });
    
    window.onbeforeunload = () => localStorage.clear();
    window.addEventListener('unload', () => {
      localStorage.clear();
    });
    this.ObtenerParametrizacion();
    this.authService.user.subscribe(user => {
      this.user = user;
      if (this.user?.id) {
        this.StartUserIdle();
      }
    });
    // await this.environment.GetSystemInformations();
  }

  logoutSesion() {
    const parametro: VerificaSesionME = {
      idUsuario: this.user?.id,
      esMovil: false
    };
    this.accesoService.apiV10AccesoVerificaSesionPost(parametro).subscribe(() => {
    });
  }

  ObtenerParametrizacion(): void {
    this.parametrizacionService.apiV10ParametrizacionObtenerParametrizacionGet().subscribe(parametrizacion => {
      this.parametrizacion = parametrizacion;
    });
  }

  StartUserIdle(): void {
    this.userIdle.stopWatching();
    this.userIdle.setConfigValues({
      idle: (this.parametrizacion?.tiempoCaducidadSesion || 1) * 60,
      ping: 60,
      timeout: 5
    });

    this.userIdle.onTimerStart().subscribe(count => {});
    this.userIdle.onTimeout().subscribe(() => {
      this.userIdle.stopWatching();
      if(this.user?.id != null && this.user?.id != ''){
        localStorage.setItem(this.sessionKey, '');
        const parametro: VerificaSesionME = {
          idUsuario: this.user?.id,
          esMovil: false
        };
        this.accesoService.apiV10AccesoVerificaSesionPost(parametro).subscribe(() => {
        
          this.authService.LogOut();
          Swal.fire({
            title: "La sesión ha caducado",
            text: "Vuelva a iniciar sesión.",
            confirmButtonText: "Ok",
            confirmButtonColor: "#3b7851",
            allowOutsideClick: false,
          }).then((result) => {
            if (result.isConfirmed) {
              window.location.reload();
            }
          });        
        });
      }
      
      this.authService.LogOut();
    });
    //this.ResetUserIdle();
    this.userIdle.startWatching();
  }

  ResetUserIdle(): void {
    const eventList = [
      'click',
      'keydown',
      'DOMouseScroll',
      'mousedown',
      'touchmove',
      'touchstart',
      'scroll',
      'keyup'
    ];
    for (const event of eventList) {
      document.body.addEventListener(event, () => {
        this.userIdle.resetTimer();
      });
    }
  }
}
